import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchWasteTypesThunk = createAsyncThunk(
  "wasteTypeMaster/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/waste-types");
      if (!res.data?.success) {
        return rejectWithValue(res.data?.message || "Failed");
      }
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || err.message || "Server error"
      );
    }
  }
);

export const createWasteTypeThunk = createAsyncThunk(
  "wasteTypeMaster/create",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const res = await api.post("/api/waste-types", payload);
      if (!res.data?.success) {
        return rejectWithValue(res.data?.message || "Failed");
      }
      dispatch(fetchWasteTypesThunk());
      return true;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || err.message || "Server error"
      );
    }
  }
);

export const updateWasteTypeThunk = createAsyncThunk(
  "wasteTypeMaster/update",
  async ({ id, payload }, { rejectWithValue, dispatch }) => {
    try {
      const res = await api.put(`/api/waste-types/${id}`, payload);
      if (!res.data?.success) {
        return rejectWithValue(res.data?.message || "Failed");
      }
      dispatch(fetchWasteTypesThunk());
      return true;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || err.message || "Server error"
      );
    }
  }
);

export const deleteWasteTypeThunk = createAsyncThunk(
  "wasteTypeMaster/delete",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const res = await api.delete(`/api/waste-types/${id}`);
      if (!res.data?.success) {
        return rejectWithValue(res.data?.message || "Failed");
      }
      dispatch(fetchWasteTypesThunk());
      return true;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || err.message || "Server error"
      );
    }
  }
);

const wasteTypeMasterSlice = createSlice({
  name: "wasteTypeMaster",
  initialState: {
    wasteTypeList: [],
    loading: false,
    saving: false,
    error: null,
  },
  reducers: {
    clearWasteTypeError(state) {
      state.error = null;
    },
    clearWasteTypes(state) {
      state.wasteTypeList = [];
      state.loading = false;
      state.saving = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWasteTypesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWasteTypesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.wasteTypeList = action.payload || [];
      })
      .addCase(fetchWasteTypesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load";
      })

      .addMatcher(
        (a) =>
          a.type === createWasteTypeThunk.pending.type ||
          a.type === updateWasteTypeThunk.pending.type ||
          a.type === deleteWasteTypeThunk.pending.type,
        (state) => {
          state.saving = true;
          state.error = null;
        }
      )
      .addMatcher(
        (a) =>
          a.type === createWasteTypeThunk.fulfilled.type ||
          a.type === updateWasteTypeThunk.fulfilled.type ||
          a.type === deleteWasteTypeThunk.fulfilled.type,
        (state) => {
          state.saving = false;
        }
      )
      .addMatcher(
        (a) =>
          a.type === createWasteTypeThunk.rejected.type ||
          a.type === updateWasteTypeThunk.rejected.type ||
          a.type === deleteWasteTypeThunk.rejected.type,
        (state, action) => {
          state.saving = false;
          state.error = action.payload || "Operation failed";
        }
      );
  },
});

export const { clearWasteTypeError, clearWasteTypes } =
  wasteTypeMasterSlice.actions;

export default wasteTypeMasterSlice.reducer;